import {
    $,
    $$,
    createElement,
    empty,
    getParentElementByAttribute,
    getParentElementByClassName,
    getParentElementByTagName,
    hide,
    html_chargement_en_cours,
} from "../../core/js/Dom.ts";
import {$get, $postForm, ajaxResponse} from "../../core/js/Ajax.ts";
import {initSelects} from "../../core/js/Select.ts";
import {animateLoadingButton, fadeIn, fadeOut, fadeOutFadeIn} from "../../core/js/Animate.ts";
import {SelecteurDeServices} from "../../core/js/SelecteurDeServices.ts";
import {initTooltips} from "../../core/js/Tooltip.ts";
import {generateModale, initHistoryModal, registerModalListener, showModal} from "../../core/js/Modal.ts";
import {enableHabilitationAvanceesButton, refreshPage} from "../../core/js/Utils.ts";
import {createErrorNotification, createSuccessNotification} from "../../portail/js/Notifications.ts";
import {createDataTables} from "../../core/js/DataTables.ts";
import {InitChampAdress} from "../../core/js/InitChampAdress.ts";

let delai = false
let selecteurDeService: SelecteurDeServices

document.addEventListener('DOMContentLoaded', function () {
    if (document.body.dataset.url === 'administration_des_services') {
        selecteurDeService = new SelecteurDeServices(window.Openscop.selecteur.administration)
        initListeners()
        selecteurDeService.addEventListener('showAdministrationService', initAdministrationService)
        if (location.search) {
            const params = new URLSearchParams(window.location.search);
            if (params.has('user_id')) {
                requestPanneauDroite(params.get('user_id')!, params.get('service_id')!, true, false)
            } else if (params.has('service_id')) {
                requestPanneauDroite(params.get('service_id')!, params.get('service_id')!, false, false)
            }
        }
    }
    if (document.body.dataset.url === 'administration_listes_des_services_sans_utilisateur') {
        initDataTableListeAdministration(4, "Aucun service")
        $("#select-instance")?.addEventListener('change', function (event: DOMEvent<HTMLSelectElement>) {
            window.location.href = event.target?.slim.getSelected()
        })
    }
    if (document.body.dataset.url === 'listes_des_administrateurs_instance') {
        initDataTableListeAdministration(7, "Aucun utilisateur")
        $("#select-instance")?.addEventListener('change', function (event: DOMEvent<HTMLSelectElement>) {
            window.location.href = event.target?.slim.getSelected()
        })
    }

    if (document.body.dataset.url === 'gerer-user-organisation' || document.body.dataset.url === 'gerer-membre-cdsr') {
        selecteurDeService = new SelecteurDeServices(window.Openscop.selecteur.administration)
        initListeners()
        selecteurDeService.addEventListener('showAdministrationService', initAdministrationService)
    }
    if (document.body.dataset.url === 'fiche_organisation') {
        initListeners()
        initAdministrationService()
    }
})

function handleReponsableStructureOrganisatriceForm(container: HTMLElement) {
    $("#input_responsable_juridique_nom_prenom_s", container)?.addEventListener('change', function (event: DOMEvent<HTMLElement>) {
        const collapseElement = $('#collapse_responsable_juridique_nom_prenom_s')
        const collapse = window.dsfr(collapseElement).collapse
        const target = getParentElementByTagName(event.target, 'input') as HTMLInputElement
        if (target.checked) {
            collapse?.disclose()
            $<HTMLSelectElement>("#id_responsable_juridique_fk", container)?.slim?.setSelected([])
        } else {
            collapse?.conceal()
        }
    })
    $("#id_responsable_juridique_fk", container)?.addEventListener('change', function () {
        if ($<HTMLInputElement>("#input_responsable_juridique_nom_prenom_s", container)?.checked) {
            const collapseElement = $('#collapse_responsable_juridique_nom_prenom_s')
            const collapse = window.dsfr(collapseElement).collapse
            $("#input_responsable_juridique_nom_prenom_s", container)?.setAttribute("checked", "false");
            collapse?.conceal()
        }
    })
}

export function initAdministrationService() {
    $<HTMLButtonElement>('#toggle-edit-structure-form-hidden')?.addEventListener('click', handleShowHiddenFormInput)
    $<HTMLFormElement>('#btn-ajouter-groupe-utilisateur')?.addEventListener('click', handleClickShowSimpleForm)
    $$<HTMLFormElement>('.delete-user-organisation').forEach(el => el.addEventListener('click', handleToggleConfirmRemoveUserFromOrganisation))
    $$('.valide-delete-organisation').forEach(el => el.addEventListener('click', handleValidRemoveUserFromOrganisation))
    $$('.dismis-delete').forEach(el => el.addEventListener('click', handleToggleConfirmRemoveUserFromOrganisation))
    $$('.notification_switch').forEach(el => el.addEventListener('change', handleUpdateNotifications))
    $$('.tfa_obligatoire_b_switch').forEach(el => el.addEventListener('change', handleTfaObligatoire))
    $$('.mail_test').forEach(el=> el.addEventListener('click', handleMailTest))
    $$('a.service-list-item').forEach(el => el.addEventListener('click', handleServiceLinkClicked))
    $$('.edit-interaction').forEach(el => el.addEventListener('click', handleClickShowSimpleForm))
    $$('.btn_add_user_equipe_utilisateur').forEach(el => el.addEventListener('click', handleClickShowSimpleForm))
    $$('.btn_update_equipe_utilisateur').forEach(el => el.addEventListener('click', handleClickShowSimpleForm))
    $$('.btn_delete_equipe_utilisateur').forEach(el => el.addEventListener('click', function (event: DOMEvent<HTMLElement>) {
        if (confirm("Êtes-vous sur de vouloir supprimer ce groupe ?")) {
            window.location = event.target.dataset.url
        }
    }))
    // changement de status du service
    $$('.edit_service_active').forEach(el => el.addEventListener('click', function (event: DOMEvent<HTMLElement>) {
        const target = getParentElementByTagName(event.target, 'button')
        const agentCount = target?.dataset.agentCount
        if (agentCount === "0") {
            handleClickShowSimpleForm(event)
        } else {
            const content = createElement('div', ['fr-alert', 'fr-alert--warning'])
            content.innerText = "La structure ne pourra être inactivée qu'après lui avoir détaché tous ses utilisateurs."
            const cancel = createElement('button', ['fr-btn', 'fr-btn--secondary'])
            cancel.innerText = "Fermer"
            cancel.setAttribute('data-micromodal-close', '')
            generateModale('delete-member-before-inactive', {
                title: "Modifier l'état du service.",
                content,
                actions: [cancel],
                title_in_header: true,
            })
        }
    }))

    initListeners()
}

function handleToggleConfirmRemoveUserFromOrganisation(event: DOMEvent<HTMLElement>) {
    const target = getParentElementByTagName(event.target, 'button')
    const parent = getParentElementByClassName(event.target, 'service_actions')
    if (target && parent) {
        if (target.classList.contains('dismis-delete')) {
            fadeOutFadeIn($('.confirm-delete-actions', parent), $('.delete-user-organisation', parent))
        } else {
            fadeOutFadeIn(target, $('.confirm-delete-actions', parent))
        }
    }
}

function handleValidRemoveUserFromOrganisation(event: DOMEvent<HTMLElement>) {
    const target = getParentElementByTagName(event.target, 'button')
    animateLoadingButton(target)
    const dataSwitch = target?.dataset.switch
    if (target) {
        if ($$(".user-organisation-list-item").length < 2 && dataSwitch === "user") {
            if (confirm('Attention, ceci est la dernière organisation de l\'utilisateur. En la retirant, son compte sera désactivé. ' +
                'L\'utilisateur ne pourra plus utiliser la plateforme')) {
                removeUserOrganisation(target.id, target?.dataset.user, target?.dataset.url)?.then(() => {
                    fadeOut(getParentElementByClassName(target, 'user-organisation-list-item-container')).then((element) => element?.remove())
                })
                const userEtat = $('#user-etat')
                const userEtatIcone = $("#icone-user-etat")
                if (userEtat) {
                    userEtat.classList.remove("text-primary")
                    userEtat.classList.add("text-danger")
                    userEtat.innerText = "Inactif"
                }
                if (userEtatIcone) {
                    userEtatIcone.classList.remove('fa-circle-check')
                    userEtatIcone.classList.add('fa-hexagon-xmark')
                    userEtatIcone.classList.remove("text-primary")
                    userEtatIcone.classList.add("text-danger")
                }
            }
        } else {
            removeUserOrganisation(target.id, target?.dataset.user, target?.dataset.url)?.then(() => {
                fadeOut(getParentElementByClassName(target, 'user-organisation-list-item-container')).then((element) => element?.remove())
            })
        }
    }
}

function handleShowHiddenFormInput(event: DOMEvent<HTMLElement>) {
    const target = event.target
    const hiddenForm = $<HTMLDivElement>('#edit-structure-form-hidden')
    if (target && hiddenForm) fadeOutFadeIn(target, hiddenForm)
}

const show_form = (id: string, title: string, url: string, data_service: boolean | string) => {
    const spinner = html_chargement_en_cours()
    const modalId = `${id}-modal`
    generateModale(modalId, {
        title: title,
        content: spinner,
        title_in_header: true,
    })
    $get(url, {
        'service_id': data_service || undefined,
    }).then(response => {
        spinner.remove()
        const content = $(`#${modalId}-modal__content`)
        if (content) {
            content.innerHTML = response.body
            // // Supprime l'adresse e-mail d'un utilisateur inactif
            $("#delete_user_email")?.addEventListener('click', function (event: DOMEvent<HTMLElement>) {
                const user_id = event.target?.dataset.user;
                const organisation_id = event.target?.dataset.service;
                if (confirm('Confirmez vous vouloir supprimer l\'adresse e-amail de cet utilisateur ? \n' +
                    'Une nouvelle devra lui être attribué avant de pouvoir être activé à nouveau')) {
                    $get("/structure/delete_user_email/", {
                        'object_id': user_id, 'organisation_id': organisation_id,
                    }).then(
                        function () {
                            window.location.reload()
                        }
                    )
                }
            })
            if (id === "edit-service-nom") {
                initServiceNameRepresentation()
            }
            if(id == "edit-service-adresse-orga"){
                InitChampAdress('id_adresse_s')
            }
            initSelects(content)
            handleReponsableStructureOrganisatriceForm(content)
        }
    })
}

const handleClickShowSimpleForm = (event: DOMEvent<HTMLElement>) => {
    const target = getParentElementByTagName(event.target, 'button')
    const id = target?.id ?? ''
    const url = target?.dataset.url ?? ''
    const title = target?.dataset.title ?? ''
    const service = target?.dataset.service ?? false
    show_form(id, title, url, service)
}


function handleUpdateNotifications(event: DOMEvent<HTMLElement>) {
    if (!delai) {
        const target = getParentElementByTagName(event?.target, 'input') as HTMLInputElement
        delai = true
        event.preventDefault()
        let type_message = target?.getAttribute('data-type_message')
        let affichage = target.checked ? "1" : "0"
        let orga_id = target.getAttribute('data-orga_id')
        $get(window.Openscop.url_changer_notification_organisation, {
            type_message,
            affichage,
            orga_id,
        }).then(() => {
            delai = false
        })
    }
}

const deleteInteraction = (id: string | null) => {
    return $get(window.Openscop.url_delete_interaction, {
        'object_id': id,
    }).then((reponse) => {
        createSuccessNotification({
            message: reponse.body
        })
    })
}

export const removeUserOrganisation = (id: string | null, user: string | undefined, url: string | undefined): Promise<void | ajaxResponse> | void => {
    if (url && id && user) {
        return $get(url, {
            'organisation_id': id,
            'user_id': user,
        }).then((response) => {
            createSuccessNotification({
                message: response.body,
            })
        })
    }
}

const initListeners = () => {
    // todo verifier ou et si vraiment necessaire ou si il faut remplacer ca par le initAdministrationService
    // toggle message d'explication pour ajouter un membre permanent (cas du CDSR par exemple)
    $('#btn-ajouter-service')?.addEventListener('click', function (event: DOMEvent<HTMLElement>) {
        fadeOutFadeIn(getParentElementByTagName(event.target, "button"), $("#alert-gestion-service"))
    })

    initInvitationsBlock(document)
    initAgentAdminActions(document)

    $$('.delete-interaction').forEach(el => el.addEventListener('click', function (event: DOMEvent<HTMLElement>) {
        const target = getParentElementByTagName(event.target, 'button') as HTMLElement
        deleteInteraction(target?.getAttribute('id')).then(() => {
            fadeOut(getParentElementByTagName(target, 'li')).then((element) => element?.remove())
        })
    }))

    // Affiche les bouttons de confirmation
    $('.delete-user-organisation')?.addEventListener('click', function (event: DOMEvent<HTMLElement>) {
        const target = getParentElementByTagName(event.target, 'button') as HTMLElement
        fadeOutFadeIn(target, target.previousElementSibling as HTMLElement)
    })

    $('.gerer-secteur-service')?.addEventListener('click', function (event: DOMEvent<HTMLElement>) {
        const target = getParentElementByTagName(event.target, 'button') as HTMLElement
        const service = target?.dataset.service
        const url = `/structure/update_service_consulte_secteur/${service}/`
        $get(url, {
            'service_id': service,
        }).then(({body}) => {
            const modal = $('#modal-form')
            if (modal) {
                // $<HTMLElement>('#modal-form-modal__title')!.innerText = 'Modifier les secteurs de ce service'
                const header = $<HTMLElement>(`#modal-form-modal-header`)!
                const titleElement = document.createElement('h2');
                titleElement.classList.add('modal__title');
                titleElement.innerText = 'Modifier les secteurs de ce service'
                header.prepend(titleElement);
                $<HTMLElement>("#modal-form-modal__content")!.innerHTML = body
                if (($("#id_is_service_regional") as HTMLInputElement)!.checked) {
                    hide($<HTMLElement>('#div_id_commune_m2m'))
                    hide($<HTMLElement>('#div_id_arrondissement_m2m'))
                    hide($<HTMLElement>('#div_id_departement_m2m'))
                }
                if (($("#id_is_service_departemental") as HTMLInputElement)!.checked) {
                    hide($<HTMLElement>('#div_id_commune_m2m'))
                    hide($<HTMLElement>('#div_id_arrondissement_m2m'))
                    hide($<HTMLElement>('#div_id_region_m2m'))
                }
                if (($("#id_is_service_arrondissement") as HTMLInputElement)!.checked) {
                    hide($<HTMLElement>('#div_id_commune_m2m'))
                    hide($<HTMLElement>('#div_id_region_m2m'))
                    hide($<HTMLElement>('#div_id_departement_m2m'))
                }
                if (($("#id_is_service_commune") as HTMLInputElement)!.checked) {
                    hide($<HTMLElement>('#div_id_arrondissement_m2m'))
                    hide($<HTMLElement>('#div_id_region_m2m'))
                    hide($<HTMLElement>('#div_id_departement_m2m'))
                }

                showModal('modal-form', {
                    onClose: () => {
                    }
                })
                initSelects(modal)

                $$('.geographie_checkbox').forEach(el => el.addEventListener('change', handleModalChangeSecteur))
            }
        })
    })

// Pour service instructeur modifie type_service_fk en fonction de type_service_instructeur_s
    $<HTMLInputElement>('#id_type_service_instructeur_s')?.addEventListener('change', function (event: DOMEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement
        if (target?.value) {
            // const selected_text = $("#id_type_service_instructeur_s option:selected")?.innerText;
            // const selected = $('#id_type_service_fk').find(`option:contains('${selected_text}')`);
            // let selected_value = selected.attr('value');
            // // Todo cela va poser problème
            // if (selected_text === "Préfecture") {
            //     selected_value = 90
            // }
            // $('#id_type_service_fk').val(selected_value)
            // $('select').trigger("chosen:updated");
        }
    })

//

// // Affiche les habilitations avancées
    enableHabilitationAvanceesButton()
}

function handleModalChangeSecteur(event: DOMEvent<HTMLElement>) {
    const modal = getParentElementByClassName(event.target, 'modal')
    const input = getParentElementByTagName(event.target, 'input') as HTMLInputElement
    if (modal && input) {
        if (input.checked) {
            if (input.id === "id_is_service_arrondissement") {
                $$<HTMLInputElement>('.geographie_checkbox').forEach((el) => {
                    if (el.id !== input.id) el.checked = false
                });
                Promise.all([fadeOut($('#div_id_commune_m2m')), fadeOut($('#div_id_region_m2m')), fadeOut($('#div_id_departement_m2m'))])
                    .then(() => fadeIn($('#div_id_arrondissement_m2m')))
                $<HTMLFormElement>('#id_commune_m2m')?.slim.setSelected([])
                $<HTMLFormElement>('#id_region_m2m')?.slim.setSelected([])
                $<HTMLFormElement>('#id_departement_m2m')?.slim.setSelected([])
                empty($('#territoire-result-name'))
            }
            if (input.id === "id_is_service_commune") {
                $$<HTMLInputElement>('.geographie_checkbox').forEach((el) => {
                    if (el.id !== input.id) el.checked = false
                });
                Promise.all([fadeOut($('#div_id_arrondissement_m2m')), fadeOut($('#div_id_region_m2m')), fadeOut($('#div_id_departement_m2m'))])
                    .then(() => fadeIn($('#div_id_commune_m2m')))
                $<HTMLFormElement>('#id_arrondissement_m2m')?.slim.setSelected([])
                $<HTMLFormElement>('#id_region_m2m')?.slim.setSelected([])
                $<HTMLFormElement>('#id_departement_m2m')?.slim.setSelected([])
                empty($('#territoire-result-name'))
            }
            if (input.id === "id_is_service_departemental") {
                $$<HTMLInputElement>('.geographie_checkbox').forEach((el) => {
                    if (el.id !== input.id) el.checked = false
                });
                Promise.all([fadeOut($('#div_id_commune_m2m')), fadeOut($('#div_id_arrondissement_m2m')), fadeOut($('#div_id_region_m2m'))])
                    .then(() => fadeIn($('#div_id_departement_m2m')))
                $<HTMLFormElement>('#id_arrondissement_m2m')?.slim.setSelected([])
                $<HTMLFormElement>('#id_commune_m2m')?.slim.setSelected([])
                $<HTMLFormElement>('#id_region_m2m')?.slim.setSelected([])
                empty($('#territoire-result-name'))
                const result = $<HTMLElement>('#territoire-result-name')
                if (result) {
                    result.innerText = input.dataset.dep!
                }
            }
            if (input.id === "id_is_service_regional") {
                $$<HTMLInputElement>('.geographie_checkbox').forEach((el) => {
                    if (el.id !== input.id) el.checked = false
                });
                Promise.all([fadeOut($('#div_id_commune_m2m')), fadeOut($('#div_id_arrondissement_m2m')), fadeOut($('#div_id_departement_m2m'))])
                    .then(() => fadeIn($('#div_id_region_m2m')))
                $<HTMLFormElement>('#id_arrondissement_m2m')?.slim.setSelected([])
                $<HTMLFormElement>('#id_commune_m2m')?.slim.setSelected([])
                $<HTMLFormElement>('#id_departement_m2m')?.slim.setSelected([])
                empty($('#territoire-result-name'))
                const result = $<HTMLElement>('#territoire-result-name')
                if (result) {
                    result.innerText = input.dataset.dep!
                }
            }
            removeError('geographie-container', 'error-geographie')
        }
    }
}


export function initInvitationsBlock(container: Document | HTMLElement | string | null) {
    if (container === null) return
    let parent: HTMLElement | Document
    if (typeof container === 'string') parent = $<HTMLElement>(container)!
    else parent = container

    async function handleReemettreInvit(event: DOMEvent<HTMLElement>) {
        event.preventDefault()
        let target = event.target
        if (target.tagName !== 'BUTTON') target = target.parentElement
        if (target.tagName !== 'BUTTON') return
        const url = target.dataset.href
        $get(url).then(data => {
            $('.invitation-liste')!.innerHTML = data.body;
            initListListener(getParentElementByAttribute(target, "role", "tabpanel")!)
        })
        // fixme : global???
        // is_admin = true
    }

    function showInvitationBlock(event: DOMEvent<HTMLElement>) {
        const parent = getParentElementByAttribute(event.target, "role", "tabpanel")
        if (parent) {
            fadeOutFadeIn($(".invitation_btn", parent)!, $(".invitation_block", parent)!)
        }
        else {
            fadeOutFadeIn($(".invitation_btn")!, $(".invitation_block")!)
        }
    }

    function hideInvitationBlock(event: DOMEvent<HTMLElement>) {
        const parent = getParentElementByAttribute(event.target, "role", "tabpanel")
        if (parent) {
            // On supprime le message d'erreur
            hide($<HTMLElement>('#invitation-erreur'))
            // On masque l'input email
            const emailInput = $<HTMLInputElement>('.invit-email', parent)
            if (emailInput) emailInput.style.borderColor = ""
            fadeOutFadeIn($(".invitation_block", parent)!, $(".invitation_btn", parent)!)
        }
        else {
            // On supprime le message d'erreur
            hide($<HTMLElement>('#invitation-erreur'))
            // On masque l'input email
            const emailInput = $<HTMLInputElement>('.invit-email')
            if (emailInput) emailInput.style.borderColor = ""
            fadeOutFadeIn($(".invitation_block")!, $(".invitation_btn")!)
        }
    }

    function handleFormSubmit(event: DOMEvent<HTMLElement>) {
        event.preventDefault();
        const parent = getParentElementByAttribute(event.target, "role", "tabpanel")
        if (parent) {
            const form = $<HTMLFormElement>('.invit-form', parent)
            if (form) {
                const donnees = new FormData(form);
                if ($<HTMLInputElement>(".invit-email", parent)!.value) {
                    const url = `/structure/ajax/invitation/`
                    const liste = $<HTMLElement>('.invitation-liste', parent)
                    const invitEmail = $<HTMLInputElement>('.invit-email', parent)
                    $postForm(url, donnees)
                        .then(data => {
                            liste!.innerHTML = data.body;
                            liste!.classList.add('fr-alert', 'fr-alert--success', 'fr-my-2w');
                            liste!.classList.remove('d-none');
                            invitEmail!.style.borderColor = '';
                            invitEmail!.value = "";
                            initListListener(parent)
                            hide($<HTMLElement>('#invitation-erreur'))
                        }).catch((err) => {
                        const invitErreur = $('#invitation-erreur')
                        if (invitErreur) {
                            liste!.classList.add('d-none');
                            invitErreur!.innerHTML = err.message
                            invitErreur.classList.remove('d-none')
                        }
                    })
                } else {
                    createErrorNotification({message: "Veuillez saisir une adresse e-mail."})
                }
            }
        }
        else {
            const form = $<HTMLFormElement>('.invit-form')
            if (form) {
                const donnees = new FormData(form);
                if ($<HTMLInputElement>(".invit-email")!.value) {
                    const url = `/structure/ajax/invitation/`
                    const liste = $<HTMLElement>('.invitation-liste')
                    const invitEmail = $<HTMLInputElement>('.invit-email')
                    $postForm(url, donnees)
                        .then(data => {
                            liste!.innerHTML = data.body;
                            liste!.classList.add('fr-alert', 'fr-alert--success', 'fr-my-2w');
                            liste!.classList.remove('d-none');
                            invitEmail!.style.borderColor = '';
                            invitEmail!.value = "";
                            hide($<HTMLElement>('#invitation-erreur'))
                        }).catch((err) => {
                        const invitErreur = $('#invitation-erreur')
                        if (invitErreur) {
                            liste!.classList.add('d-none');
                            invitErreur!.innerHTML = err.message
                            invitErreur.classList.remove('d-none')
                        }
                    })
                } else {
                    createErrorNotification({message: "Veuillez saisir une adresse e-mail."})
                }
            }
        }
    }

    function handleDeleteInvitation(event: DOMEvent<HTMLElement>) {
        event.stopPropagation()
        const target = event.target
        const parent = getParentElementByTagName(target, 'button')
        const tabElement = getParentElementByAttribute(target, "role", "tabpanel")
        if (parent && tabElement) {
            const id_invit = parent.dataset.invitation
            const id_organisation = parent.dataset.service!
            const url = parent.dataset.ajaxUrl
            const formData = new FormData()
            formData.append('service_id', id_organisation)
            $postForm(`${url}?id=${id_invit}`, formData).then(data => {
                const liste = $<HTMLElement>('.invitation-liste', tabElement)
                liste!.innerHTML = data.body;
                initListListener(tabElement)
            })
        }
        else {
            const id_invit = target.parentElement!.dataset.invitation
            const id_organisation = target.parentElement!.dataset.service!
            const url = target.parentElement!.dataset.ajaxUrl
            const formData = new FormData()
            formData.append('service_id', id_organisation)
            $postForm(`${url}?id=${id_invit}`, formData).then(data => {
                const liste = $<HTMLElement>('.invitation-liste')
                liste!.innerHTML = data.body;
                initListListener(liste!)
            })
        }
    }

    const initListListener = (parentElement: HTMLElement) => {
        $$(".del_invit", parentElement).forEach((element) => {
            element.addEventListener("click", handleDeleteInvitation)
        })
        $$(".reemettre_invit", parentElement).forEach((element) => {
            element.addEventListener("click", handleReemettreInvit)
        })
    }


    $$(".ajouter-invitation", parent).forEach(element => element.addEventListener("click", showInvitationBlock))
    $$(".invit-quit", parent).forEach(element => element.addEventListener("click", hideInvitationBlock))
    $$('.invit-form', parent).forEach(element => {
        element.addEventListener("submit", handleFormSubmit)
    })
    $$('.reemettre_invit', parent).forEach(element => element.addEventListener("click", handleReemettreInvit))
    $$<HTMLElement>('.invitation-liste', parent).forEach(element => {
        initListListener(element)
    })
}

export function initAgentAdminActions(container: Document | HTMLElement | string | null) {
    if (container === null) return
    let parent: HTMLElement | Document
    if (typeof container === 'string') parent = $<HTMLElement>(container)!
    else parent = container

    registerModalListener(parent)
}

export function handleServiceLinkClicked(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const item = getParentElementByTagName(event.target, 'a') as HTMLAnchorElement
    // @ts-ignore
    const {resetBtn} = animateLoadingButton(item, 'Chargement...')
    const object_id = new URL(item.href).hash.slice(1);
    const service_id = item?.dataset.service!;
    const is_user = item?.classList.contains('organisation_user')
    const isOwnUser = item?.classList.contains('own-profil')
    requestPanneauDroite(object_id, service_id, is_user, isOwnUser, resetBtn)
}

function requestPanneauDroite(object_id: string, service_id: string, is_user: boolean, isOwnUser: boolean, resetBtn: any = null) {
    if (document.body.dataset.url === 'fiche_organisation' && !is_user) {
        resetBtn()
        window.location.href = `${window.Openscop.url_fiche_organisation_js}${object_id}`
        return
    }
    if (["profile_publique", "profile", "fiche_organisation"].includes(document.body.dataset.url!)) {
        if (isOwnUser) {
            // profile
            resetBtn()
            window.location.href = `/accounts/profile/`
            return
        }
        // profile_publique
        resetBtn()
        window.location.href = `/profile/${object_id}/`
        return
    }
    const container = $('#service_selectionne')
    if (object_id) {
        if (container) {
            empty(container)
            container.append(html_chargement_en_cours("Chargement en cours", ['blocs-chargement-spinner', 'fr-alert', 'fr-alert--info', 'fr-mt-4w', 'fr-py-2w']))
        }
        if (resetBtn) resetBtn()
        let url
        if (is_user) {
            history.pushState(null, '', `?service_id=${service_id}&user_id=${object_id}`);
            url = selecteurDeService.options.urls.url_detail_user
        } else {
            history.pushState(null, '', `?service_id=${object_id}`);
            url = selecteurDeService.options.urls.url_selecteur_action
        }
        $get(url, {
            'administration': true,
            'object_id': object_id,
            'organisation_id': service_id ? service_id : ''
        }).then((data) => {
            if (container) {
                empty(container)
                container.innerHTML = data.body
                initSelects(container)
                initTooltips(container)
                initHistoryModal(container)
                selecteurDeService.dispatchEvent(new CustomEvent('showAdministrationService'))
                $$('a.link-interaction').forEach((link) => link.addEventListener('click', handleServiceLinkClicked))
            }
        }).catch(() => {
            if (container) {
                empty(container)
                container.innerHTML = `<div class='fr-alert fr-alert--warning fr-py-4w'>Vous n'êtes pas habilité à voir ces informations.</div>`
            }
        })

    }
}

export function initAddServiceModal(modalId: string, isNationnal: boolean, categorie: string) {
    const modal = $(`#${modalId}`)
    if (modal) {
        hide($<HTMLElement>('#div_id_arrondissement_m2m'))
        hide($<HTMLElement>('#div_id_region_m2m'))
        hide($<HTMLElement>('#div_id_departement_m2m'))
        if (categorie !== "structure") {
            hide($<HTMLElement>('#div_id_commune_m2m'))
        }
        initSelects(modal)
        if (!isNationnal && categorie !== "structure") {
            initServiceGeographieInputs()
        }
        initServiceNameRepresentation()
        $('form', modal)?.addEventListener('submit', submitAddServiceForm)

        $('#id_type_service_fk')?.removeAttribute('required')
    }
}

export function initServiceGeographieInputs() {
    if (($("#id_is_service_regional") as HTMLInputElement)?.checked) {
        hide($<HTMLElement>('#div_id_commune_m2m'))
        hide($<HTMLElement>('#div_id_arrondissement_m2m'))
        hide($<HTMLElement>('#div_id_departement_m2m'))
    }
    if (($("#id_is_service_departemental") as HTMLInputElement)?.checked) {
        hide($<HTMLElement>('#div_id_commune_m2m'))
        hide($<HTMLElement>('#div_id_arrondissement_m2m'))
        hide($<HTMLElement>('#div_id_region_m2m'))
    }
    if (($("#id_is_service_arrondissement") as HTMLInputElement)?.checked) {
        hide($<HTMLElement>('#div_id_commune_m2m'))
        hide($<HTMLElement>('#div_id_region_m2m'))
        hide($<HTMLElement>('#div_id_departement_m2m'))
    }
    if (($("#id_is_service_commune") as HTMLInputElement)?.checked) {
        hide($<HTMLElement>('#div_id_arrondissement_m2m'))
        hide($<HTMLElement>('#div_id_region_m2m'))
        hide($<HTMLElement>('#div_id_departement_m2m'))
    }
    $$('.geographie_checkbox').forEach(el => el.addEventListener('change', handleModalChangeSecteur))
    $('#id_region_m2m')?.addEventListener('change', () => {
        removeError('geographie-container', 'error-geographie')
    })
    $('#id_departement_m2m')?.addEventListener('change', () => {
        removeError('geographie-container', 'error-geographie')
    })
    $('#id_arrondissement_m2m')?.addEventListener('change', () => {
        removeError('geographie-container', 'error-geographie')
    })
    $('#id_commune_m2m')?.addEventListener('change', () => {
        removeError('geographie-container', 'error-geographie')
    })
}


export function initServiceNameRepresentation() {
    const typeResultName = $('#type-result-name')
    const precisionResultName = $('#precision-result-name')
    const territoireResultName = $('#territoire-result-name')

    if (typeResultName) {
        $('#id_type_service_fk')?.addEventListener('change', () => {
            setTimeout(() => {
                typeResultName.innerText = $("#div_id_type_service_fk .ss-single")?.innerText?.split('(')[0]!
                removeError('div_id_type_service_fk', 'error_type_service_fk')
            })
        })
        $('#id_service_parent_fk')?.addEventListener('change', function () {
            removeError('div_id_service_parent_fk', 'error_service_parent_fk')
        })
    }

    if (territoireResultName) {
        // le settimeout permet d'attendre la mise à jour du dom
        $('#id_region_m2m')?.addEventListener('change', () => {
            let territoire_str = " ";
            setTimeout(() => {
                $$('#div_id_region_m2m .ss-value-text').forEach((el) => {
                    territoire_str += `${el.innerText} `
                })
                territoireResultName.innerText = `${territoire_str}`
            })
        })
        $('#id_departement_m2m')?.addEventListener('change', function () {
            setTimeout(() => {
                let territoire_str = " ";
                $$("#div_id_departement_m2m .ss-value-text").forEach((el) => {
                    territoire_str += `${el.innerText.split('-')[0]} `
                })
                territoireResultName.innerText = `${territoire_str}`
            })
        })
        $('#id_arrondissement_m2m')?.addEventListener('change', function () {
            setTimeout(() => {
                let territoire_str = " ";
                $$("#div_id_arrondissement_m2m .ss-value-text").forEach((el) => {
                        territoire_str += `${el.innerText} `
                    }
                )
                territoireResultName.innerText = `${territoire_str}`
            })
        })
        $('#id_commune_m2m')?.addEventListener('change', function () {
            setTimeout(() => {
                let territoire_str = " ";
                $$("#div_id_commune_m2m .ss-value-text").forEach((el) => {
                        territoire_str += `${el.innerText} `
                    }
                )
                territoireResultName.innerText = `${territoire_str}`
            })

        })
    }

    if (precisionResultName) {
        $('#id_precision_nom_s')?.addEventListener('keyup', (event: DOMEvent<HTMLInputElement>) => {
            const target = event.target
            if (target.value) {
                precisionResultName.innerText = ` ${target.value}`
            } else {
                empty(precisionResultName)
            }
        })
    }
}

function submitAddServiceForm(event: DOMEvent<HTMLFormElement>) {
    event.preventDefault()
    const target = event.target
    const data = new FormData(target)

    // 1, pas de type de service.
    const typeServiceError = submitCheckTypeService()

    // 2, pas de sélection de secteur dans le cas d'un admin d'instance ou pour arrondissement et commune pour un groupe support.
    const geoGraphieError = submitCheckGeographie()

    // 3, pas de sélection de secteur région ou département pour un groupe support
    const parentServiceError = submitCheckParentService()

    if (!typeServiceError && !geoGraphieError && !parentServiceError) {
        $postForm(target.action, data).then(() => {
            refreshPage()
        })
    }
}


function submitCheckGeographie() {
    let errors = false
    const nationalSwitch = $<HTMLInputElement>('#id_national_b')
    const commune = $<HTMLSelectElement>('#id_commune_m2m')?.slim!
    const region = $<HTMLSelectElement>('#id_region_m2m')?.slim!
    const arrondissement = $<HTMLSelectElement>('#id_arrondissement_m2m')?.slim!
    const departement = $<HTMLSelectElement>('#id_departement_m2m')?.slim!
    const isCommune = $<HTMLInputElement>('#id_is_service_commune')
    const isRegion = $<HTMLInputElement>('#id_is_service_regional')
    const isArrondissement = $<HTMLInputElement>('#id_is_service_arrondissement')
    const isDepartement = $<HTMLInputElement>('#id_is_service_departemental')
    if (nationalSwitch) {
        if (!nationalSwitch.checked) {
            errors = true
            showError('div_id_national_b', 'error_national', 'Une organisation d\'instance nationale doit être nationale.')
        }
    } else {
        // todo : removeError lors du changement sur le select pas que sur le switch
        if (isDepartement && isRegion && isCommune && isArrondissement) {
            if (!isDepartement.checked && !isRegion.checked && !isArrondissement.checked && !isCommune.checked) {
                errors = true
                showError('geographie-container', 'error-geographie', 'Pas de géographie renseignée.')
            }
            // check geographie
            if ((isDepartement.checked && departement && departement.getSelected().length < 1)) {
                errors = true
                showError('geographie-container', 'error-geographie', 'Pas de géographie renseignée.')
            }
            if ((isRegion.checked && region && region.getSelected().length < 1)) {
                errors = true
                showError('geographie-container', 'error-geographie', 'Pas de géographie renseignée.')
            }
            if ((isArrondissement.checked && arrondissement.getSelected().length < 1)) {
                errors = true
                showError('geographie-container', 'error-geographie', 'Pas de géographie renseignée.')
            }
            if ((isCommune.checked && commune.getSelected().length < 1)) {
                errors = true
                showError('geographie-container', 'error-geographie', 'Pas de géographie renseignée.')
            }
        }
    }
    return errors
}

function submitCheckTypeService() {
    let errors = false
    const select = $<HTMLSelectElement>('#id_type_service_fk')
    if (select) {
        const typeServiceSelect = select.slim!

        if (typeServiceSelect.getSelected().length < 1 || (typeServiceSelect.getSelected().length === 1 && typeServiceSelect.getSelected()[0] === "")) {
            errors = true
            showError('div_id_type_service_fk', 'error_type_service_fk', 'Ce champ est obligatoire.')
        }
    }
    return errors
}

function submitCheckParentService() {
    let errors = false
    const serviceParent = $<HTMLSelectElement>('#id_service_parent_fk')
    if (serviceParent) {
        const serviceParentSelect = serviceParent.slim!
        if (serviceParent?.required) {
            if (serviceParentSelect.getSelected().length < 1 || (serviceParentSelect.getSelected().length === 1 && serviceParentSelect.getSelected()[0] === "")) {
                errors = true
                showError('div_id_service_parent_fk', 'error_service_parent_fk', 'Ce champ est obligatoire.')
            }
        }
    }
    return errors
}

function showError(container: string, error: string, message: string) {
    const typeElement = $(`#${container}`)
    if (typeElement) {
        const typeError = $(`#${error}`)
        typeElement.classList.add('fr-alert', 'fr-alert--error')
        if (!typeError) {
            const child = createElement('span')
            child.id = error
            child.innerHTML = `<strong>${message}</strong>`
            typeElement?.appendChild(child)
        }
    }
}

function removeError(container: string, error: string) {
    const typeElement = $(`#${container}`)
    if (typeElement) {
        const typeError = $(`#${error}`)
        typeElement.classList.remove('fr-alert', 'fr-alert--error')
        if (typeError) {
            typeError.remove()
        }
    }
}

function handleTfaObligatoire(event: DOMEvent<HTMLInputElement>) {
    if (!delai) {
        const target = event.target
        delai = true
        event.preventDefault()
        let tfa_obligatoire_b = target.checked ? "1" : "0"
        let orga_id = target.getAttribute('data-orga_id')
        $get(window.Openscop.url_changer_notification_organisation_2fa, {tfa_obligatoire_b, orga_id})
            .finally(() => {
                delai = false
            })
    }
}

function handleMailTest(event: DOMEvent<HTMLInputElement>){
    const target = event.target
    event.preventDefault()
    $get(target.getAttribute('data-url')).then((r) => {
        let content = createElement('div', [])
        content.innerHTML = `<p>Le message ci-dessous va être envoyé dans quelques instants vers ${r.body.to}<br>
            Cette adresse est destinataire des notifications quotidiennes selon le paramétrage actuel du service.</p>
            <p>Objet : ${r.body.subjet}</p>
            <blockquote>${r.body.content}</blockquote>
            <p>Suivez dans quelques minutes l'envoi de ce message depuis le <a href="/admin/post_office/email/${r.body.pk}/change/" target="_blank">Log d'envoi email</a></p>`
        generateModale('message_test_modal', {
            title: "Envoi de message test",
            content,
            actions: [],
        })
    })
}

function initDataTableListeAdministration(nombre_colone=4, message_liste_vide="", order_by=0) {

    let select = {}
    let columns_export_option = ''

    function formatExportcolumn(_data: any, _row: number, _column: number, node: HTMLElement) {
        let returnData = node.textContent?.trim()
        const child = $('span[hidden]', node)
        if (child) returnData = child.innerText
        return returnData
    }


    createDataTables('#service-sans-utilisateur-table', {
        language: {
            emptyTable: message_liste_vide,
        },
        paging: false,
        info: false,
        columnDefs: nombre_colone,
        select: select,
        dom: 'Bfrtip',
        buttons: {
            buttons: [
                {
                    extend: 'csv',
                    text: "Télécharger en csv",
                    className: 'fr-btn fr-mb-1w supprimer_class',
                    exportOptions: {
                        columns: columns_export_option,
                        format: {body: formatExportcolumn},
                    }
                },
                {
                    extend: 'excelHtml5',
                    text: "Télécharger en excel",
                    className: 'fr-btn fr-mb-1w supprimer_class',
                    exportOptions: {
                        columns: columns_export_option,
                        format: {body: formatExportcolumn},
                    }
                },
                {
                    extend: 'pdfHtml5',
                    text: "Télécharger en pdf",
                    className: 'fr-btn fr-mb-1w supprimer_class',
                    orientation: 'landscape',
                    pageSize: 'A3',
                    exportOptions: {
                        columns: columns_export_option,
                        format: {body: formatExportcolumn},
                    }
                },
                {
                    extend: 'print',
                    text: "Imprimer",
                    className: 'fr-btn fr-mb-1w  supprimer_class',
                    exportOptions: {
                        columns: columns_export_option,
                        format: {body: formatExportcolumn},
                    }
                },
            ],
        },
        colReorder: true,
        fixedHeader: true,
        order: [[order_by, "asc"]],
    })
}